import { IKeyVals } from 'state/tags/tags.types'

export const getCategoryValues = (categoryIds: string[], invLabels?: IKeyVals) => {
  if (invLabels && invLabels?.vals?.length > 0 && categoryIds?.length > 0) {
    return categoryIds
      .map((cat) => {
        const label = invLabels?.vals?.find((label) => label?.val_id === cat)?.val || ''
        return label
      })
      .join(', ')
  }
  return ''
}

export const getCategoryValueArray = (categoryIds: string[], invLabels?: IKeyVals) => {
  if (invLabels && invLabels?.vals?.length > 0 && categoryIds?.length > 0) {
    return categoryIds.map((cat) => {
      const label = invLabels?.vals?.find((label) => label?.val_id === cat)?.val || ''
      return label
    })
  }
  return []
}
